import { useStore } from 'vuex'
import { onMounted,computed } from 'vue'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'
import formatNewlines from 'foundation/js/formatNewlines'

export default {
    name: "MemberOverlay",

    setup(){
        const store = useStore()

        const isSubmitting = computed(()=> store.state.forum.is_submitting)
        const userId = computed(()=> store.state.main.page_overlay_content_data.userId)

        let first,
            last,
            close
        
        const memberData = computed(()=>{
            return store.state.forum.member_data
        })

        
        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        onMounted(() => {
            store.dispatch('forum/getMemberData', { userId: userId.value })
            first = document.querySelector('.kb-member-overlay__answers-link[data-order="first"]')
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback({
                opening(){
                    close.focus()
                }
            }, { persistent: true })
        })

        const getLabel = (labelKey) =>
            store.getters["labels/getLabel"]({
                labelCollection: "MemberOverlay",
                labelKey,
            });
        
        return {
            memberData,
            isSubmitting,
            getLabel,
            tabTrap,
            formatNewlines
        }
    }
}